import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
export function createTrackConfig() {
  return {
    poizon_venue_component_content_click(platform: any) {
      return {
        current_page: 82,
        block_type: 176,
        venue_id: this.props.editConfig.id,
        venue_title: document.title,
        poizon_component_type: 'poizon-coupon-activity',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
    poizon_venue_component_content_exposure(platform: any) {
      return {
        current_page: 82,
        block_type: 176,
        venue_id: this.props.editConfig.id,
        venue_title: document.title,
        poizon_component_type: 'poizon-coupon-activity',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
  } as any
}
